import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/google-auth/callback`;

// DTO Type for parameters
export type ConnectGoogleDriveCallbackDTO = {
  code: string;
  state: string;
};

export type ConnectGoogleDriveCallbackResponse = {
  accessToken: string;
};

// Function to generate API URL
export const getConnectGoogleDriveCallbackUrl = (projectId: string | number) =>
  generateRoutePath(url, { projectId });

export const connectGoogleDriveCallback = (
  params: ConnectGoogleDriveCallbackDTO
): Promise<ConnectGoogleDriveCallbackResponse> => {
  return axios.get(url, { params: { ...params }, showError: false });
};

type UseConnectGoogleDriveCallbackOptions = {
  config?: MutationConfig<typeof connectGoogleDriveCallback>;
};

export const useConnectGoogleDriveCallback = ({
  config,
}: UseConnectGoogleDriveCallbackOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: (props: ConnectGoogleDriveCallbackDTO) => connectGoogleDriveCallback(props),
  });
};
